<template>
  <div class="rapids-picker">
    <div class="autocomplete-wrapper">
      <PickerInput
        ref="suggestInput"
        :picker-id="pickerId"
        :aria-describedby="pickerId + '-rapids-hint ' + pickerId + '-rapids-details'"
        :aria-activedescendant="descendantAsign(highlightedIndex, pickerId, '-option-')"
        :aria-controls="showSuggestions ? pickerId + '-suggestions' : null"
        aria-label="Rapids search"
        type="search"
      />

      <SuggestionsDropdown
        :picker-id="pickerId"
        :show-suggestions="showSuggestions"
        :suggestions="suggestions"
        :highlighted-index="highlightedIndex"
        :dropdown-style="dropdownStyle"
        dropdowntype="rapids"
        @select-suggestion="selectSuggestion"
        @update-highlighted="highlightedIndex = $event"
      />

      <LoadingIndicator :loading="loading" />
    </div>

    <span
      v-if="shownLabel"
      class="chosen-label"
    >
      {{ chosen?.label }}
    </span>

    <input
      :id="inputId"
      :value="fieldValue"
      :name="inputName"
      type="hidden"
    />

    <p v-if="debug">
      <strong>Hidden Input:</strong> {{ inputName }}={{ fieldValue }}<br />
      <strong>Initial Value:</strong> {{ inputValue }}
    </p>
  </div>
</template>

<script>
import BasePicker from './base_picker';
import LoadingIndicator from './LoadingIndicator.vue';
import PickerInput from './PickerInput.vue';
import SuggestionsDropdown from './SuggestionsDropdown.vue';
import './vue_picker.css';

export default {
  name: 'RapidsPicker',

  components: {
    LoadingIndicator,
    PickerInput,
    SuggestionsDropdown,
  },

  extends: BasePicker,

  props: {
    // Required. ID to assign hidden input. Visible input is suffixed with _picker.
    inputId: {
      type: String,
      default: 'rapids_picker_no_id',
    },
    // Required. Name to assign hidden input. Visible input is suffixed with _picker.
    inputName: {
      type: String,
      default: 'rapids_picker_no_name',
    },
    // Optional ('code'). Controls how the component's value (and hidden value) behaves. Supports:
    // * code - Stores the RAPIDS code as the value (e.g. 1132R-CB).
    // * id - Stores the underlying database identifier.
    valueMode: {
      validator(val) {
        return ['rapids_code', 'id'].includes(val);
      },
      default: 'rapids_code',
    },
    // Optional (false). Controls display of debug information.
    debug: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    chosen(val) {
      const {
        labelExternalId,
        fieldValue,
      } = this;

      this.setExternalText(labelExternalId, 'labelExternalId', 'label', val);
      this.$emit('change', fieldValue);
    },
  },

  methods: {
    apiUrl() {
      return '/lookup/apprenticeship_lookups.json';
    },

    async fetchSuggestions() {
      try {
        const results = await this.populateLookupData();

        this.suggestions = results.slice(0, 20); // Max 20
        this.showSuggestions = true;
        this.highlightedIndex = -1;
        this.takeLocation();
      } catch (_error) {
        this.suggestions = [];
        this.showSuggestions = false;
      }
    },
  },
};
</script>
